import { computed, ref } from 'vue'

/** Main header is detached (fixed) and reacting to scroll direction. */
export const mainHeaderPinningActive = ref(false)

/** Measured height of the pinned main header. */
export const mainHeaderRevealHeight = ref(0)

/** Main header is currently slid into view (scroll up). */
export const mainHeaderRevealed = ref(false)

/** Sticky `top` offset for ContextNavigationTabs — sits below the revealed header. */
export const contextTabsStickyTop = computed(() =>
  mainHeaderPinningActive.value && mainHeaderRevealed.value
    ? mainHeaderRevealHeight.value
    : 0
)

/** Gap below the header / viewport top for right-column sticky panels (matches `lg:top-8`). */
const STICKY_PANEL_GAP_PX = 32

/** Sticky `top` offset for right-column panels — below the revealed header when visible. */
export const stickyPanelTop = computed(() =>
  mainHeaderPinningActive.value && mainHeaderRevealed.value
    ? mainHeaderRevealHeight.value + STICKY_PANEL_GAP_PX
    : STICKY_PANEL_GAP_PX
)

export function resetStickyMainHeaderState() {
  mainHeaderPinningActive.value = false
  mainHeaderRevealHeight.value = 0
  mainHeaderRevealed.value = false
}
